/* eslint-disable react/style-prop-object */
import axios from "axios";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import Close from "../../../../Helpers/CloseBtn/Close";
import trans from "../../../../../utils";
import { SpeedUnit } from "../../../../../JsHelpers/PlatformUnits";
import { toast } from "react-toastify";

export default function ObjectDraggableData({ data, position, view, setview }) {
	const [geoCode, setGeoCode] = useState(false);
	const inf = useSelector((state) => state.users.user);
	console.log("data", data);
	console.log("position", position);
	const fetchGeoCodePosition = async (lat, lon) => {
		try {
			const response = await axios.get(
				`https://nominatim.openstreetmap.org/reverse.php?lat=${lat}&lon=${lon}&zoom=18&format=jsonv2`
			);
			setGeoCode(`${response.data.display_name}`);
			return `${response.data.display_name}`;
		} catch (error) {
			toast.error(trans("Error fetching geocode position:"), {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
		}
	};
	const truncateItem = (text) => {
		const maxLength = 15;
		return text.length > maxLength
			? text.substring(0, maxLength) + "..."
			: text;
	};
	return (
		<>
			{view ? (
				<div className="object-draggable-objects">
					<div className="object-draggable-content">
						<span>{trans("Acc")} : </span>
						<div>{data?.status === "online" ? trans("ON") : trans("OFF")}</div>
					</div>
					<div className="object-draggable-content">
						<span>{trans("status")} : </span>
						<div>
							{position?.attributes.motion === true
								? trans("Moving")
								: trans("Stopped")}
						</div>
					</div>
					<div className="object-draggable-content">
						<span>{trans("Speed")} : </span>
						<div>
							{data.status === "online"
								? SpeedUnit(position?.speed, inf.attributes.speedUnit || "kn")
								: `0 ${trans(inf.attributes.speedUnit) || "kn"}`}
						</div>
					</div>
					<div className="object-draggable-content">
						<span>GPS : </span>
						<div>
							{data?.status === "online"
								? trans("Available")
								: trans("UnAvailable")}
						</div>
					</div>
					<div className="object-draggable-content">
						<span>GMS : </span>
						<div>
							{position?.accuracy
								? `${Math.round(position?.accuracy)}%`
								: "N/A"}
						</div>
					</div>
					<div className="object-draggable-content">
						<span>{trans("Address")} : </span>
						<div
							onClick={() => {
								const lat = position ? position.latitude : inf.latitude;
								const lon = position ? position.longitude : inf.longitude;
								fetchGeoCodePosition(lat, lon);
							}}
							className={!geoCode ? "text-primary" : ""}
							role="button"
							title={geoCode || trans("Get current address")}
						>
							{geoCode ? truncateItem(geoCode) : trans("Get current address")}
						</div>
					</div>
					<div
						className="object-draggable-objects-exit"
						onClick={() => setview(false)}
					>
						<Close img="Close" style="close close-24" />
					</div>
				</div>
			) : (
				<div className="object-draggable-info" onClick={() => setview(true)}>
					<img src={`${process.env.PUBLIC_URL}/assets/info.svg`} alt="Info" />
				</div>
			)}
		</>
	);
}
